(ns common.schema.entities.counterparty-diligence.templates.demo.pep)

;; TODO: in progress
(def schema
  {:template/schema
   {:pep/first-name
    {:data-type :data.type/text-simple
     :label {:en "First name of the person"}}

    :pep/last-name
    {:data-type :data.type/text-simple
     :label {:en "Last name of the person"}}

    :pep/connection-to-legal-entity
    {:data-type :data.type/text-simple
     :label {:en "Connection to legal entity"}}

    :pep/relationship-to-pep
    {:data-type :data.type/keyword
     :label {:en "Relationship to PEP"}
     :options [{:value :self
                :label {:en "The person herself / himself is a PEP"
                        :fi "Henkilö itse"}}
               {:value :related-person
                :label {:en "Relative or an associate"
                        :fi "Läheinen tai lähipiiriin kuuluva henkilö"}}]}}

   :template/sections
   {:pep-information
    {:ord 0
     :title {:en "PEP information"}
     :fields [:pep/first-name
              :pep/last-name
              :pep/connection-to-legal-entity
              :pep/relationship-to-pep]}}})
